const initState = {
    countryApi: 'https://api.countrystatecity.in/v1/countries/',
    serverApi: 'https://poetically-server.onrender.com/',   
    // serverApi: 'http://localhost:9090/'
}

const ApiReducer = (state=initState, action)=>{
    return state
}

export default ApiReducer